import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { postAPIHandler, useBanners } from "../../Api/api";
import { Typography } from "@mui/material";
import "./style.css";
import AdBanner from "../AdBanner";

const PointsTable = () => {
  const { seriesId } = useParams();
  const [matchPointsTable, setMatchPointsTable] = useState({});
  // console.log("matchPointsTable - ", matchPointsTable);
  const [loading, setLoading] = useState(false);

  const { square} = useBanners();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      fetchPointsTable(seriesId);
    }, 1000);
  }, [seriesId]);

  const fetchPointsTable = async (val) => {
    const formData = new FormData();
    formData.append("series_id", val);
    const response = await postAPIHandler("groupPointsTable", formData);
    setMatchPointsTable(response.data);
    setLoading(false);
  };
  // Conditional rendering for the loading state
  if (loading) {
    return (
      <Box className="px-3 py-4 my-5 text-center">
        <CircularProgress style={{ color: "#DC9A2B" }} />
      </Box>
    );
  }

  // Main content rendering
  return (
    <>
      {typeof matchPointsTable === "object" && !Array.isArray(matchPointsTable) && Object.keys(matchPointsTable).length > 0 ? (
        Object.entries(matchPointsTable).map(([groupName, teams]) => (
          <div key={groupName} className="md:my-6 pt-8 mx-4">

            {/* ==========Advertisement============== */}
            <div className="md:w-[15%] float-left hidden lg:block">
              <AdBanner data={square} type="horizontal" />
            </div>

            <div className="gap-1 d-flex flex-col lg:w-[60%] md:w-[90%] mx-auto pb-10">
              <Typography variant="h2" gutterBottom className="text-[#fff]">
                {groupName}
              </Typography>
              <div className="flex flex-wrap justify-between xl:gap-36 bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] py-3 rounded-lg lg:px-[8%] px-[5%]">
                <span>Team</span>
                <div className="md:space-x-10 space-x-2 point-table-keys">
                  <span>M</span>
                  <span>W</span>
                  <span>L</span>
                  <span>NR</span>
                  <span>Pts</span>
                  <span className="nrr">NRR</span>
                </div>
              </div>
              {Array.isArray(teams) ? (
                teams.map((team) => (
                  <div
                    key={team.teams}
                    className="flex flex-wrap justify-between xl:gap-36 w-100 py-3 rounded-lg mt-2 bg-[#232525] hover:bg-[#393c3c] lg:px-[8%] px-[5%]"
                  >
                    <div className="flex gap-2 items-center">
                      <img
                        src={team.flag}
                        alt={team.teams}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                        }}
                      />
                      {team.teams} {team.QE !== null && team.length > 1 && <span style>`(${team.QE})`</span>}
                    </div>
                    <div className="md:space-x-10 space-x-2 point-table-keys">
                      <span>{team.P}</span>
                      <span>{team.W}</span>
                      <span>{team.L}</span>
                      <span>{team.NR}</span>
                      <span>{team.Pts}</span>
                      <span className="nrr">{team.NRR}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-white my-10 py-4 bg-[#242424] w-50 mx-auto rounded-lg">
                  Invalid Data Format
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="text-center text-white my-10 py-4 bg-[#242424] w-50 mx-auto rounded-lg">
          No Data Found
        </div>
      )}

    </>
  );
};

export default PointsTable;
